import { render, staticRenderFns } from "./CustomerServiceDropdownLists.vue?vue&type=template&id=6ce60fe2&scoped=true"
import script from "./CustomerServiceDropdownLists.vue?vue&type=script&lang=js"
export * from "./CustomerServiceDropdownLists.vue?vue&type=script&lang=js"
import style0 from "./CustomerServiceDropdownLists.vue?vue&type=style&index=0&id=6ce60fe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce60fe2",
  null
  
)

export default component.exports